import { render, staticRenderFns } from "./subject_cont.vue?vue&type=template&id=5806eef6&scoped=true"
import script from "./subject_cont.vue?vue&type=script&lang=js"
export * from "./subject_cont.vue?vue&type=script&lang=js"
import style0 from "./subject_cont.vue?vue&type=style&index=0&id=5806eef6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5806eef6",
  null
  
)

export default component.exports